import loadable from "@loadable/component";
import { ErrorBoundary } from "../../../components";
import FullPageLoader from "@Components/FullPageLoader";

const ThirdPartyInfoDesktop = loadable(() => import("./ThirdPartyInfoDesktop"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <ThirdPartyInfoDesktop {...props} />
  </ErrorBoundary>
);
